export enum Locales {
  NL = 'nl',
}
